import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { Checkbox, Button, Box, Typography, Modal, Dialog, DialogActions, DialogTitle } from '@mui/material'
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DaumPostcode from 'react-daum-postcode';
import {CgSearch} from 'react-icons/cg';


const useStyles = makeStyles((theme) => ({
  editProfileBlock:{
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  row:{
    maxWidth:'1280px', 
        margin:'0 auto', 
        padding:'310px 10px 70px 10px',

        [theme.breakpoints.down(1025)]: {
            padding:'150px 10px 0px 10px',
        }
  },
  editProfileBlockH1:{ 
    textAlign:'center',
    fontSize:'35px',
  },
  appListH3:{
    borderBottom:'2px solid #007235',
    fontSize:'22px',
    fontWeight:'400',
    paddingBottom:'10px',
    display:'flex',
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  leftData:{
    padding:'0 10px'
  },
  editProfileFlexDiv:{
    display:'flex',
    justifyContent:'space-around',
    paddingTop:'3%',

    [theme.breakpoints.down(1025)]: {
        flexDirection: 'column'
    }
  },
  leftDiv:{
    width:'45%',

    [theme.breakpoints.down(1025)]: {
        width:'100%',
        padding:'0 20px',
    }
  },
  rightDiv:{
    width:'45%',

    [theme.breakpoints.down(1025)]: {
        width:'100%',
        padding:'20px 20px 0 20px',
    }
  },
  appListLi:{
    padding:'40px 0 0 0px'
  },
  divSpan:{
    display:'block',
    paddingBottom:'10px',
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  appContentInput:{
    width:'100%',
    height: '40px',
    padding:'0 0 0 8px',
    borderRadius:'3px',
    border:'1px solid #CCCCCC',
    fontFamily:[
      'Noto Sans KR'
    ],
    '&::placeholder':{
        color:'#CCCCCC'
    },
    '&:focus-within':{
        outline:'none'
    },
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    padding:'50px 0'
  },
  addStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #007235',
    borderRadius:3,
    boxShadow: 24,
    p: 4,
    [theme.breakpoints.down(1025)]: {
        width:'100%',
    }
}

}))

const EditProfile = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let navigate = useNavigate();
  const location = useLocation();
  const mbNo = useSelector(state => state.user.userInfo['mb_no']);

  const [mbId, setMbId] = useState('');
  const [mbPassword, setMbPassword] = useState('');
  const [mbPassCheck, setMbPassCheck] = useState('');
  const [mbName, setMbName] = useState('');
  const [mbEmail, setMbEmail] = useState('');
  const [mbHp, setMbHp] = useState('');
  const [mbTel, setMbTel] = useState('');
  const [mbZip1, setMbZip1] = useState('');
  const [mbZip2, setMbZip2] = useState('');
  const [mbAddr1, setMbAddr1] = useState('');
  const [mbAddr2, setMbAddr2] = useState('');
  const [mbAddr3, setMbAddr3] = useState('');
  const [mbSms, setMbSms] = useState(0);
  const [mbStoreName, setMbStoreName] = useState('');
  const [mbBizNo, setMbBizNo] = useState('');
  const [mbBizName, setMbBizName] = useState('');
  const [mbBizTaxMail, setMbBizTaxMail] = useState('');

  const [open, setOpen] = useState(false);
  const [dialog, setDialog] = useState('');

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  useEffect(() => {
    if (!location.state.auth) {
      navigate("/");
    }
  } , [location.state.auth])

  const getItem = async() => {
    try {
        const res = await axios.post('/api/user/userEditView/', {mb_no: mbNo})

        if(res.data.success === false) {
            setDialog('불러오기 실패')
            return;
        }

        const result = res.data.result

        setMbId(result['mb_id'])
        setMbName(result['mb_name'])
        setMbEmail(result['mb_email'])
        setMbHp(result['mb_hp'])
        setMbTel(result['mb_tel'])
        setMbZip1(result['mb_zip1'])
        setMbZip2(result['mb_zip2'])
        setMbAddr1(result['mb_addr1'])
        setMbAddr2(result['mb_addr2'])
        setMbAddr3(result['mb_addr3'])
        setMbSms(result['mb_sms'])
        setMbStoreName(result['mb_storename'])
        setMbBizNo(result['mb_biz_no'])
        setMbBizName(result['mb_biz_name'])
        setMbBizTaxMail(result['mb_biz_tax_mail'])
    
      } catch (e) {
        console.log(e)
      }
  }

  useEffect(() => {
    if(mbNo){
      getItem()
    }
  }, [mbNo])


  const onSubmit = async() => {
    if(mbName === '') {
      setDialog('이름을 입력해주세요')
      setLoading(false)
      return
    }
    if(mbEmail === '') {
      setDialog('이메일을 입력해주세요')
      setLoading(false)
      return
    }
    if(mbHp === '') {
      setDialog('휴대폰번호를 입력해주세요')
      setLoading(false)
      return
    }
    if(mbZip1 === '') {
      setDialog('주소를 선택해주세요')
      setLoading(false)
      return
    }
    if(mbAddr2 === '') {
      setDialog('상세주소를 입력해주세요')
      setLoading(false)
      return
    }
    if(mbStoreName === '') {
      setDialog('상호명을 입력해주세요')
      setLoading(false)
      return
    }
    if(mbBizNo === '') {
      setDialog('사업자등록번호를 입력해주세요')
      setLoading(false)
      return
    }
    if(mbBizName === '') {
      setDialog('대표자명을 입력해주세요')
      setLoading(false)
      return
    }

    if(mbPassword !== '' && mbPassword !== mbPassCheck) {
      setDialog('비밀번호를 확인해주세요')
      setLoading(false)
      return
    }
    if(mbPassword !== '' && mbPassword.length < 5) {
      setDialog('비밀번호를 5자 이상 입력 해주세요')
      setLoading(false)
      return
    }



    try {
      const res = await axios.post('/api/user/userEdit/', {
          mb_no: mbNo,
          mb_password: mbPassword,
          mb_name: mbName,
          mb_email: mbEmail,
          mb_hp: mbHp,
          mb_tel: mbTel,
          mb_zip1: mbZip1,
          mb_zip2: mbZip2,
          mb_addr1: mbAddr1,
          mb_addr2: mbAddr2,
          mb_addr3: mbAddr3,
          mb_sms: mbSms,
          mb_storename: mbStoreName,
          mb_biz_no: mbBizNo,
          mb_biz_name: mbBizName,
          mb_biz_tax_mail: mbBizTaxMail
      })

      if(res.data.success === false) {
        setDialog('실패하였습니다.')
        setLoading(false)
          return;
      }

      setDialog('성공')
      navigate("/");
  
    } catch (e) {
      setLoading(false)
      console.log(e)
    }

  }

  useEffect(() => {

    return () => {
      setMbId('')
      setMbPassword('')
      setMbPassCheck('')
      setMbName('')
      setMbEmail('')
      setMbHp('')
      setMbTel('')
      setMbZip1('')
      setMbZip2('')
      setMbAddr1('')
      setMbAddr2('')
      setMbAddr3('')
      setMbSms(0)
      setMbStoreName('')
      setMbBizNo('')
      setMbBizName('')
      setMbBizTaxMail('')
    }
  }, [])


  const handle = {
    // 버튼 클릭 이벤트
    handleOpen: () => {
        setOpen(current => !current);
    },

    // 주소 선택 이벤트
    selectAddress: (data) => {
        let zip1 = data.zonecode.substr(0, 3);
        let zip2 = data.zonecode.substr(3, 3);
        let addr1 = data.address

        setMbZip1(zip1)
        setMbZip2(zip2)
        setMbAddr1(addr1)
        setOpen(false);
    },
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #007235',
    borderRadius:3,
    boxShadow: 24,
    p: 4,
  };

  return (
    <div className={classes.editProfileBlock}>
      <div className={classes.row}>
        <h1 className={classes.editProfileBlockH1}>정보수정</h1>
        <h3 className={classes.appListH3}>
          <div className={classes.leftData}>아이디</div>
          {mbId}
        </h3>
        <div className={classes.editProfileFlexDiv}>
          <div className={classes.leftDiv}>
            <div>
              <span className={classes.divSpan}>비밀번호</span>
              <input 
                type='password' 
                className={classes.appContentInput} 
                placeholder='비밀번호를 입력해주세요' 
                value={mbPassword}
                onChange={(e) => {setMbPassword(e.target.value)}}
              />
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>비밀번호 확인</span>
              <input 
                type='password' 
                className={classes.appContentInput} 
                placeholder='비밀번호를 한번더 입력해주세요' 
                value={mbPassCheck}
                onChange={(e) => {setMbPassCheck(e.target.value)}}
              />
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>이름</span>
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='이름을 입력해주세요' 
                value={mbName}
                onChange={(e) => { setMbName(e.target.value) }}
              />
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>주소</span>
              <Button 
                  onClick={() => setOpen(true)} 
                  style={{
                      background:'#fff',
                      color:'#007235',
                      border:'1px solid #007235',
                      width:'100%',
                      marginBottom:'10px',
                      fontFamily:[
                        'Noto Sans KR'
                      ],
                  }}
              >
                  <CgSearch />
                  주소검색
              </Button>
              <Modal
                  open={open}
                  onClose={() => setOpen(false)}
              >
                  <Box sx={classes.addStyle}>
                      <Typography 
                          id="modal-modal-description" 
                          variant="span" 
                          sx={{ 
                              mt: 2,
                          }}                                               
                      >
                          <DaumPostcode 
                              onComplete={handle.selectAddress}  // 값을 선택할 경우 실행되는 이벤트
                              autoClose={false} // 값을 선택할 경우 사용되는 DOM을 제거하여 자동 닫힘 설정 
                          />
                      </Typography>
                  </Box>
              </Modal>   
              <div>{mbZip1 + mbZip2}</div>
              <div>{mbAddr1}</div>
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='상세주소를 입력해주세요' 
                value={mbAddr2}
                onChange={(e) => { setMbAddr2(e.target.value) }}
              />
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='상세주소를 입력해주세요 (선택)' 
                value={mbAddr3}
                onChange={(e) => { setMbAddr3(e.target.value) }}
              />
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>이메일</span>
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='이메일을 입력해주세요' 
                value={mbEmail}
                onChange={(e) => { setMbEmail(e.target.value) }}
              />
            </div>
          </div>

          <div className={classes.rightDiv}>
            <div>
              <span className={classes.divSpan}>전화번호</span>
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='전화번호를 입력해주세요' 
                value={mbTel}
                onChange={(e) => { setMbTel(e.target.value) }}
              />
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>휴대폰</span>
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='휴대폰번호를 입력해주세요' 
                value={mbHp}
                onChange={(e) => { setMbHp(e.target.value) }}
              />
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>SMS 수신</span>
              <Checkbox 
                checked={mbSms === 0 ? false : true}
                onChange={() => {
                  mbSms === 0 ?
                  setMbSms(1) :
                  setMbSms(0)
                }}
                style ={{
                  color: "#007235",
                }}
              />
              SMS를 통한 상품/이벤트 정보수신에 동의합니다.[선택]
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>상호명</span>
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='상호명을 입력해주세요' 
                value={mbStoreName}
                onChange={(e) => { setMbStoreName(e.target.value) }}
              />
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>사업자등록번호</span>
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='사업자등록번호를 입력해주세요' 
                value={mbBizNo}
                onChange={(e) => { setMbBizNo(e.target.value) }}
              />
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>대표자성명</span>
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='대표자성명을 입력해주세요' 
                value={mbBizName}
                onChange={(e) => { setMbBizName(e.target.value) }}
              />
            </div>
            <div className={classes.appListLi}>
              <span className={classes.divSpan}>세금계산서 발행 메일</span>
              <input 
                type='text' 
                className={classes.appContentInput} 
                placeholder='세금계산서 발행 메일 입력해주세요' 
                value={mbBizTaxMail}
                onChange={(e) => { setMbBizTaxMail(e.target.value) }}
              />
            </div>
          </div>
        </div>
        <div className={classes.btnDiv}>

        {loading ? (
          <div>수정을 진행중입니다</div>
        ) : (
            <>
            <Button 
                variant="outlined"
                onClick={() => {
                  setLoading(true)
                  setTimeout(() => onSubmit(), 1000) 
                }}
                style={{ 
                  color:'#fff',
                  border:'1px solid #007235',
                  background:'#007235',
                  width:'100%',

                  fontFamily:[
                    'Noto Sans KR'
                  ],

                }}
            >
                수정
            </Button>
            </>
        )}

        </div>
      </div>

      <Dialog
        open={dialog === '' ? false : true}
        onClose={() => setDialog('')}
      >
        <DialogTitle id="alert-dialog-title">
          {dialog}
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => setDialog('')} autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default EditProfile
